export const PUBLIC_PROFILE_TYPE_USER = 'user',
  PUBLIC_PROFILE_TYPE_TEAM = 'team';
